export default {
	start: {
		title: "AI-plattform",
		tips: "Gjør scrolling om til penger! Ta ut daglig med ett trykk – Telefonen din er din pengemaskin!"
	},
	login: {
		tips: "Har du ikke en konto?",
		Signup: "Registrer deg",
		logIn: "Logg inn",
		Remember: "Husk meg",
		form: {
			label: ["Brukernavn/Telefon", "Passord"]
		},
		forgotPassword: "Glemt passord?",
		contactSupport: "Kontakt kundeservice",
		title: "Opprett konto",
		content: ["Trenger du en konto?", "Opprett en her"]
	},
	register: {
		form: {
			label: [
				"Brukernavn",
				"Telefon",
				"Transaksjonspassord",
				"Påloggingspassord",
				"Bekreft påloggingspassord",
				"Kjønn",
				"Invitasjonskode",
				"E-post",
				"Verifiseringskode"
			],
			rule: {
				Username: "Brukernavn må være 4–10 tegn",
				Email: "Vennligst oppgi en gyldig e-post",
				Phone: "Telefonnummer må være minst 4 sifre",
				ConfirmLoginPassword: "Passordene stemmer ikke overens",
				TradingPassword: "Transaksjonspassord må være minst 6 sifre",
				LoginPassword: "Påloggingspassord må være minst 6 sifre"
			}
		},
		sendMsg: "Kode sendt! Sjekk meldingen din.",
		agree: ["Jeg godtar {0}", "Personvernregler, MSA", "og", "Vilkår for bruk"],
		content: [
			"Opprett en gratis konto",
			"Har du allerede en konto?",
			"Logg inn her",
			"Opprett konto",
			"Ved å fortsette godtar du våre"
		]
	}
};
